// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ComplianceService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Compliance';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useComplianceService: () => UseQueryResult<
  TemplateContract<ComplianceService> | null,
  string
> = () =>
  useOperatorBasedQuery('queryComplianceService', (ledgerApi, offset, operator) =>
    ledgerApi.queryComplianceService(offset, operator),
  );

export default useComplianceService;
